import propTypes from 'prop-types';

function PageSectionHeader({ children }) {
  return (
    <div className="page-section-header">
      {children}
    </div>
  );
}

PageSectionHeader.propTypes = {
  children: propTypes.node
};

PageSectionHeader.defaultProps = {
  children: null
};

export default PageSectionHeader;
